import { DataItem } from "./types";
import { getFormatDate } from "~/libs/getFormatDate";

export const transformDataTable = (dataItems: DataItem[]) => {
  if (!dataItems || !Array.isArray(dataItems)) {
    return [];
  }

  return dataItems.map((item: DataItem) => {
    const { Positions, createdAt, updatedAt, name, createdBy, UpdatedBy, id } =
      item;

    const positionsNames =
      Positions && Array.isArray(Positions)
        ? Positions.map(
            (position) => position.Position && position.Position.name
          )
        : [];

    return {
      id,
      name,
      Positions: positionsNames,
      createdAt: getFormatDate(createdAt),
      updatedAt: getFormatDate(updatedAt),
      createdBy,
      UpdatedBy,
    };
  });
};
